<template>
  <section class="section mobile_div section_bg container-fluid" >
    <loading-block v-if="is_load==false" :loading="!is_load"/>
    <div class="container" v-if="is_load">
      <div class="section_header mobile_div  d-flex justify-content-center   " >
        <nav aria-label="breadcrumb" class=""   >
          <ol class="breadcrumb" >
            <li class="breadcrumb-item"><router-link tag="a"  :to="'/project/'+project.last_id" >{{ project.name_project}}</router-link></li>
            <li class="breadcrumb-item active" aria-current="page">Счета</li>
          </ol>
        </nav>
      </div>
    </div>

    <div class="container " v-if="is_load">


        <div class="section_header mobile_div" v-if="can_add==true">
          <div class="alert alert-danger" v-if="new_invoice_iserror==true">
            <p>{{ new_invoice_error }}</p>
          </div>
          <div class="row">
            <div class="form-group col-md-12">
              <label for="exampleUser">Пользователь </label>
              <select id="exampleUser" v-if="is_load==true" required v-model="newInvoice.user_id"
                  class="form-control">
                <option v-if="user.last_id!=me.last_id || (user.role=='spectator' && user.isapprove==0)"
                    v-for="user in users" :value="user.last_id"
                    :key="user.last_id">@{{
                    user.name
                  }}
                </option>

              </select>


            </div>

          </div>
          <div class="row">
            <div class="col-12  mb-2 mt-2">
              <select id="currency" class="form-control" @change="changeTypePay" v-model="newInvoice.type_pay">
                <option :value="'one'">единоразовая</option>
                <option :value="'every_month'">раз в месяц</option>
                <option :value="'every_year'">раз в год</option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-12 " :class="{'col-md-5':is_show_pre_sum,'col-md-12':!is_show_pre_sum}">
              <label for="exampleSum">Сумма </label>
              <input type="text" class="form-control" required id="exampleSum" v-model="newInvoice.sum"
                  placeholder="Введите сумму">

            </div>
            <div class="form-group col-12 col-md-5" v-if="is_show_pre_sum">
              <label for="exampleSum">Предоплата </label>
              <input type="text" class="form-control" required id="exampleSum" v-model="newInvoice.prepaid_sum"
                  placeholder="Введите сумму предоплаты">

            </div>

          </div>
          <div class="row">
            <div class="form-group col-12 col-md-5">
              <label for="exampleTypeInvoice">Тип </label>
              <select id="exampleTypeInvoice" v-if="is_load==true" required
                  class="form-control" v-model="newInvoice.type">
                <option value="client" >
                  должен
                  оплатить
                </option>
                <option value="developer" >
                  должен получить
                </option>
              </select>


            </div>
            <div class="form-group col-12 col-md-5">
              <label for="exampleCurrency5">Валюта </label>
              <select id="exampleCurrency5" v-if="is_load==true" required
                  class="form-control" v-model="newInvoice.currency">
                <option v-for="(current_currency,currency_index) in currencys"
                    :value="current_currency" :key="currency_index">
                  {{ current_currency }}

                </option>

              </select>


            </div>
          </div>
          <div class="row">

            <div class="col-12">
              <input type="text" class="form-control" required id="exampleTitle5" v-model="newInvoice.title"
                  placeholder="Введите описание">
            </div>

          </div>
          <div class="row d-flex justify-content-center">
            <base-button   @click="addInvoice()" class="mb-2 mt-2">Создать счет</base-button>
          </div>

        </div>


        <div class="section_header mobile_div" v-if="invoices.length==0">
        <div class="row d-flex justify-content-center" >
          <h2 class="text-center">Счета не найдены!</h2>
        </div>
        </div>

      <div class="card alert alert-warning" v-if="is_error">
        <p v-html="error_message"></p>
      </div>
      <div class="section_header mobile_div  mt-2">

        <h4 >Описание статусов</h4>
        <p><badge pill
            type="warning">не утвержден
        </badge> - Счет создан исполнителем, но не подтвержден клиентом.</p>
        <p><badge pill
            type="success"> утвержден
        </badge> - Счет создан исполнителем, и подтвержден клиентом.</p>

        <p><badge pill
            type="success"> завершено
        </badge> - Клиент подтвердил, что все условия по счету выполнены и после этого создается счет на оплату </p>


      </div>
        <div class="section_header mobile_div row mt-2" v-if="invoices.length>0" v-for="(project_invoice,index) in invoices"
            :key="project_invoice.last_id">
          <div class="col-md-2"> <router-link v-if="project_invoice.client.last_id && project_invoice.client.name"     tag="a"
              :to="{name: 'user_page_main', params: { user_id: project_invoice.client.last_id }}" >@{{ project_invoice.client.name }}</router-link> <i
              class="fa fa-arrow-right"></i>
            <router-link v-if="project_invoice.developer.last_id && project_invoice.developer.name"     tag="a"
                :to="{name: 'user_page_main', params: { user_id: project_invoice.developer.last_id }}" >@{{ project_invoice.developer.name }}</router-link>
          </div>

          <div class="col-md-3">
            <p>{{ project_invoice.sum }} {{ project_invoice.currency }}</p>
            <div v-if="project_invoice.prepaid_sum>0">
              <p><br>предоплата:<br>
              {{ project_invoice.prepaid_sum }} {{ project_invoice.currency }}
              </p>
            </div>
            <div v-if="project_invoice.type && project_invoice.type=='every_month'">
              <p><br>тип:<br>
              <span class="badge badge-info">каждый месяц</span>
              </p>
            </div>
            <div v-if="project_invoice.type && project_invoice.type=='every_year'">
              <p><br>тип:<br>
              <span class="badge badge-info">каждый год</span>
              </p>
            </div>
          </div>
          <div class="col-md-3">
            <p>{{ project_invoice.title }}</p>
            <p v-if="project_invoice.service_start_at && project_invoice.service_end_at">&nbsp;<i class="fa fa-calendar"></i>&nbsp;<span class="badge badge-info">{{ project_invoice.service_start_at }}</span> - <span class="badge badge-info">{{ project_invoice.service_end_at}}</span></p>


          </div>

          <div class="col-md-2">


            <router-link v-if="project_invoice.final!=null && project_invoice.final.ispay!=1" :to="{name: 'invoice', params: { id: project_invoice.final.last_id }}"><badge pill v-if="project_invoice.final!=null && project_invoice.final.ispay!=1"
                type="warning">ожидает оплаты
            </badge> </router-link>


            <badge pill
                v-if="project_invoice.is_approve_client==0 && (me.last_id==project_invoice.developer_id || me.last_id==project_invoice.client_id) "
                type="warning">не утвержден
            </badge>
            <badge pill
                v-if="project_invoice.is_approve_client==1 &&  project_invoice.is_finish==0 && (me.last_id==project_invoice.developer_id || me.last_id==project_invoice.client_id)"
                type="success"> утвержден
            </badge>

            <badge pill
                v-if="project_invoice.is_approve_client==1 &&  project_invoice.is_finish==1 && me.last_id==project_invoice.developer_id"
                type="success"> завершено
            </badge>

            <badge pill
                v-if="project_invoice.is_approve_client==1 &&  project_invoice.is_finish==1 && me.last_id==project_invoice.client_id"
                type="success"> завершено
            </badge>

            <button class="btn btn-sm"
                v-if="project_invoice.is_approve_client==0 && project_invoice.client_id==me.last_id"
                @click="approveInvoice($event,index)">Подтвердить
            </button>
            <button  class="btn btn-sm"
                v-if="!(project_invoice.type && project_invoice.type=='every_month' || project_invoice.type=='every_year') && project_invoice.is_approve_client==1 && project_invoice.is_finish==0 && project_invoice.client_id==me.last_id"
                @click="completeInvoice($event,index)">Все сделано
            </button>
            <button class="btn btn-sm"
                v-if="(project_invoice.type && project_invoice.type=='every_month' || project_invoice.type=='every_year') && project_invoice.is_approve_client==1 && project_invoice.is_finish==0 && project_invoice.client_id==me.last_id"
                @click="completeInvoice($event,index)">Создать счет
            </button>

            <button class="btn btn-sm mt-1"
                v-if="(project_invoice.type && project_invoice.isautorenewwal==1 && (project_invoice.type=='every_month' || project_invoice.type=='every_year')) && (project_invoice.developer_id==me.last_id || project_invoice.client_id==me.last_id) && project_invoice.is_finish==1 "
                @click="cancelInvoice($event,project_invoice.last_id)">отменить</button>

            <button class="btn btn-sm mt-1"
                v-if="(project_invoice.type && project_invoice.isautorenewwal==0 && (project_invoice.type=='every_month' || project_invoice.type=='every_year')) && (project_invoice.developer_id==me.last_id || project_invoice.client_id==me.last_id) && project_invoice.is_finish==1 "
                @click="makeInvoice($event,project_invoice.last_id)">создать<br>счет</button>

            <button class="btn btn-sm mt-1"
                v-if="project_invoice.is_approve_client==0 && (project_invoice.developer_id==me.last_id || project_invoice.client_id==me.last_id) "
                @click="removeInvoice($event,project_invoice.last_id)"><i
                class="  fa fa-remove"></i></button>
          </div>
        </div>
        <div class="col-12 col-sm-12 mt-5 ml-1  " v-if="total>offset && invoices.length>0">
          <div class="row second_section d-flex justify-content-center">
            <button class="btn" @click="moreLoad">Загрузить еще</button>

          </div>
        </div>

    </div>
  </section>
</template>

<script>
import Api from "@/models/Api";
import UserModel from "@/models/UserModel";
import LoadingBlock from "@/components/Custom/LoadingBlock";

export default {
  name: "ProjectInvoices",
  data(){
    return {
      "project":null,
      "is_load":false,
      "invoices":[],
      "limit":10,
      "offset":0,
      "total":0,
      'user':null,
      'me':null,
      'users':null,
      'can_add':false,
      'new_invoice_iserror': false,
      'new_invoice_error': null,
      'newInvoice': {},
      'is_show_pre_sum':true,
      'is_error':false,
      'error_message':'',


    }
  },
  components:{
    LoadingBlock
  },
  mounted(){
    var app=this;

    app.firstLoading();


  },
  methods:{
    changeTypePay(){
     var app=this;
     if(app.newInvoice.type_pay=="one"){
       app.is_show_pre_sum=true;
     }else {
       app.is_show_pre_sum=false;
     }

    },
    addInvoice() {
      var app = this;
      var project_id = app.project.last_id;
      var newInvoice = app.newInvoice;
      Api.addProjectInvoice(project_id, newInvoice, function (data) {
        app.new_invoice_iserror = false;

        app.firstLoading();
      }, function (message) {
        app.new_invoice_iserror = true;
        app.new_invoice_error = message;
      })


    },
    setDefaultInvoice(){
      var app=this;
      app.newInvoice={
      };
      app.newInvoice.currency=app.currencys[0];
      app.newInvoice.type_pay='one';
      app.newInvoice.type='client';
      for (const [key, user] of Object.entries(app.users)) {
        if(user.last_id!=app.me.last_id || (user.role=='spectator' && user.isapprove==0)){
          app.newInvoice.user_id=user.last_id;
          break;
        }
      }
    },
    moreLoad(){
      var app=this;
      let id = app.$route.params.id;
      Api.getProjectInvoices(id,app.limit,app.offset,function(data){
        app.invoices=app.invoices.concat(data.invoices);
        app.total=data.total;
        app.offset=data.offset;

      },function(err){


      })
    },
    firstLoading(){
      var app=this;
      app.is_load=false;
      let id = app.$route.params.id;
      app.offset=0;

      Api.getProjectInvoices(id,app.limit,app.offset,function(data){
        app.project=data.project;
        app.user=data.user;
        app.invoices=data.invoices;
        app.total=data.total;
        app.offset=data.offset;
        app.me=data.user;
        app.can_add=data.can_add;
        app.currencys=data.currencys;
        app.users=data.users;
        app.setDefaultInvoice();

        app.is_load=true;

      },function(err){


      })
    },
    approveInvoice(event, index) {
      event.preventDefault();
      var app = this;
      var id = app.invoices[index].last_id;
      var project_id = app.project.last_id;
      Api.approveInvoice(id, project_id, function (data) {
        app.firstLoading();
      });
    },
    completeInvoice(event, index) {
      event.preventDefault();
      var app = this;
      var id = app.invoices[index].last_id;
      var project_id = app.project.last_id;
      Api.completeInvoice(id, project_id, function (data) {

        app.firstLoading();
      });
    },
    makeInvoice(event,id){
      event.preventDefault();

      var app = this;
      app.is_error=false;
      var project_id = app.project.last_id;
      Api.makeInvoice(id, project_id, function (data) {

        if(data && data.type && data.type=="error"){
          app.error_message=data.message;
          app.is_error=true;
        }else {
          app.is_error=false;
          app.firstLoading();
        }

        // for (var i = app.project.invoices.length - 1; i >= 0; --i) {
        //   if (app.project.invoices[i].last_id == id) {
        //     app.project.invoices = app.project.invoices.splice(i, 1);
        //   }
        // }
        // document.location.reload();
      });
    },
    cancelInvoice(event,id){
      event.preventDefault();

      var app = this;
      var project_id = app.project.last_id;
      Api.cancelInvoice(id, project_id, function (data) {


        app.firstLoading();
        // for (var i = app.project.invoices.length - 1; i >= 0; --i) {
        //   if (app.project.invoices[i].last_id == id) {
        //     app.project.invoices = app.project.invoices.splice(i, 1);
        //   }
        // }
        // document.location.reload();
      });
    },
    removeInvoice(event, id) {
      event.preventDefault();

      var app = this;
      var project_id = app.project.last_id;
      Api.removeInvoice(id, project_id, function (data) {


        app.firstLoading();
        // for (var i = app.project.invoices.length - 1; i >= 0; --i) {
        //   if (app.project.invoices[i].last_id == id) {
        //     app.project.invoices = app.project.invoices.splice(i, 1);
        //   }
        // }
        // document.location.reload();
      });

    }
  }

}
</script>

<style scoped>

</style>